/**
 * The id of AppShell's scrollport — the element in-shell pages actually scroll.
 *
 * Its own module because both ends need it and neither should pull in the other:
 * the shell sets the id, and leaf components (scroll-to-top, the document map,
 * lib/utils' jump) read it to find the scroll root. Importing it from AppShell
 * would drag the whole header/sidebar tree into every one of them.
 */
export const MAIN_SCROLLER_ID = "main-content-area"
